export default __webpack_public_path__ + "d5ed427eaf96967b58d154a0009a8e7a.png";